/* ============================================================================
   Product description enhancer
   Runs on product pages. Applies two transforms to .product-description:
     1. Replace literal typos.
     2. Promote inline "Dimensions:" / "Measurements" text to <h3>Dimensions</h3>.
   Idempotent — safe to run multiple times.
   ============================================================================ */
(function () {
  'use strict';

  var TYPOS = {
    'Adennium': 'Adenium',
    'WIlly': 'Willy',
    'Hexagona ': 'Hexagonal ',
    'for water to drainage': 'for water drainage'
  };

  // Markers that introduce a measurement section.
  // Captured prefix is stripped from the text.
  var MARKER_RE = /^\s*(Dimensions|Measurements|DIMENSIONS|MEASUREMENTS)\s*:?\s*/;

  // Heuristic for detecting unmarked measurement content.
  var BARE_MEASURE_RE = /(?:^|\s)(?:H|W|L|D|Height|Width|Length|Depth|Diameter|Seat\s+Height)\s*:?\s*\d|^\s*\d+(?:\.\d+)?\s*(?:"|in\.?|cm|ft|')\s*(?:[xX×]|H|W|L|D)/;

  function run() {
    document.querySelectorAll('.product-description').forEach(enhance);
  }

  function enhance(root) {
    if (root.dataset.enhanced === '1') return;
    root.dataset.enhanced = '1';
    fixTypos(root);
    insertDimensionsHeadings(root);
  }

  function fixTypos(root) {
    // Walk text nodes only, so we don't mangle attributes.
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      var v = node.nodeValue;
      var out = v;
      for (var bad in TYPOS) {
        if (out.indexOf(bad) !== -1) out = out.split(bad).join(TYPOS[bad]);
      }
      if (out !== v) node.nodeValue = out;
    }
  }

  function hasDimensionsHeading(scope) {
    return Array.from(scope.querySelectorAll('h2, h3, h4, h5, h6')).some(function (h) {
      return /^\s*Dimensions\s*$/i.test(h.textContent);
    });
  }

  function makeH3() {
    var h = document.createElement('h3');
    h.textContent = 'Dimensions';
    h.className = 'product-description__dimensions-heading';
    return h;
  }

  function firstTextNode(el) {
    var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        return n.nodeValue && n.nodeValue.trim() ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      }
    });
    return w.nextNode();
  }

  function insertDimensionsHeadings(root) {
    // Normalize any existing <h4>Dimensions</h4> to <h3>.
    root.querySelectorAll('h4, h5, h6').forEach(function (h) {
      if (/^\s*Dimensions\s*$/i.test(h.textContent)) {
        var h3 = makeH3();
        h.parentNode.replaceChild(h3, h);
      }
    });

    // ---- Strategy A: structured CMS-content blocks ----
    // <div class="flex py-6"> whose first text starts with "Measurements" or "Dimensions:"
    root.querySelectorAll('div.flex.py-6').forEach(function (div) {
      if (hasDimensionsHeading(div)) return;
      var tnode = firstTextNode(div);
      if (!tnode) return;
      var m = MARKER_RE.exec(tnode.nodeValue);
      if (!m) return;
      // Strip the marker prefix from the text node
      tnode.nodeValue = tnode.nodeValue.slice(m[0].length);
      // If the text node is now empty AND its parent has no other content, remove the parent
      if (!tnode.nodeValue.trim() && tnode.parentNode.childNodes.length === 1) {
        tnode.parentNode.removeChild(tnode);
      }
      // Prepend the heading and mark the container as a dimensions block
      div.insertBefore(makeH3(), div.firstChild);
      div.classList.add('product-description__dimensions');
    });

    // ---- Strategy B: <p> starting with "Dimensions:" / "Measurements" ----
    root.querySelectorAll('p').forEach(function (p) {
      // Skip if already preceded by a Dimensions heading
      var prev = p.previousElementSibling;
      if (prev && /^h[2-6]$/i.test(prev.tagName) && /^\s*Dimensions\s*$/i.test(prev.textContent)) return;

      var tnode = firstTextNode(p);
      if (!tnode) return;
      var m = MARKER_RE.exec(tnode.nodeValue);
      if (!m) return;

      tnode.nodeValue = tnode.nodeValue.slice(m[0].length);

      // If the <p> is now effectively empty (no remaining text, no children of substance), remove it
      var trimmed = p.textContent.replace(/ /g, '').trim();
      if (!trimmed) {
        p.remove();
        return;
      }
      p.parentNode.insertBefore(makeH3(), p);
      p.classList.add('product-description__dimensions');
    });

    // ---- Strategy C: bare-measurement heuristic ----
    // Any remaining <p> whose text looks like dimensions, with no Dimensions heading already above it.
    root.querySelectorAll('p').forEach(function (p) {
      var prev = p.previousElementSibling;
      if (prev && /^h[2-6]$/i.test(prev.tagName) && /^\s*Dimensions\s*$/i.test(prev.textContent)) return;
      var text = (p.textContent || '').trim();
      if (!text) return;
      if (!BARE_MEASURE_RE.test(text)) return;
      // Avoid promoting paragraphs that are mostly prose — require >30% of words to be measurement-y
      var measureWords = (text.match(/\d|"|H|W|L|D|cm|in\.?|ft|x|×/gi) || []).length;
      if (measureWords < 3) return;
      p.parentNode.insertBefore(makeH3(), p);
      p.classList.add('product-description__dimensions');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // Variant changes can re-render parts of the page — re-run on a debounced tick.
  var pending;
  document.addEventListener('variant:change', function () {
    clearTimeout(pending);
    pending = setTimeout(run, 50);
  });
})();
